module.exports = __webpack_public_path__ + "zocdoc-small-blob-logo___29m4m.svg";